import Vue from "vue";

const actions = {
  async searchEmailQueue(_, payload) {
    const { page, perPage, filter } = payload;

    const params = new URLSearchParams();

    params.append("perPage", perPage.toString());
    params.append("page", page.toString());

    if (filter.email) {
      params.append("email", filter.email.toString());
    }
    if (filter.emailType) {
      params.append("emailType", filter.emailType.toString());
    }
    if (filter.subject) {
      params.append("subject", filter.subject.toString());
    }
    if (filter.deliveryStatus) {
      params.append("deliveryStatus", filter.deliveryStatus.toString());
    }
    if (filter.userId) {
      params.append("userId", filter.userId.toString());
    }
    if (filter.programId) {
      params.append("programId", filter.programId.toString());
    }

    return await Vue.axios.get(`super/email-queue/search?${params.toString()}`);
  }
};

export default actions;
